export default __webpack_public_path__ + "assets/models/04f5bc5a3504ec48345132f0c66e3315.glb";